import React from "react";
import { motion } from "framer-motion";
import StickyNavbar from "../navbar";

const Chapter2Questions = () => {
    const questions = [
      "What are the stages of the research cycle?",
      "How can identifying a problem help in the research process?",
      "What are the key elements to describe when defining a problem?",
      "What methods can be used to gather information about an existing problem?",
      "Why is it important to check for existing solutions to a problem?",
      "How do you formulate a researchable question from a broad topic?",
      "What are the key differences between observational and experimental research?",
      "How can stakeholders be involved in the research planning process?",
      "What is the significance of the research cycle in health-related studies?",
      "How does the research cycle ensure systematic data collection and analysis?"
    ];
  
    return (
      <div>
        <StickyNavbar />
        <div className="bg-gray-50 min-h-screen p-8 mt-10">
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-8"
          >
            <h1 className="text-3xl font-bold text-blue-900">
              Chapter 2 Questions
            </h1>
          </motion.div>
          <motion.ul
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="space-y-4 text-lg"
          >
            {questions.map((question, index) => (
              <motion.li
                key={index}
                whileHover={{ scale: 1.05, x: 10 }}
                className="bg-white shadow-md p-4 rounded-lg border border-gray-200"
              >
                {index + 1}. {question}
              </motion.li>
            ))}
          </motion.ul>
        </div>
      </div>
    );
  };

  export default Chapter2Questions

